<form [formGroup]="frmGroup">
  <label *ngIf="fieldInfo.showLabel" [fieldInfo]="fieldInfo" acForLable>
    {{ fieldInfo.label
    }}<span class="required-star" *ngIf="fieldInfo.required && fieldInfo.label"
      >*</span
    >
  </label>
  <hcc-custom-validation [validations]="fieldInfo?.validations">
    <!-- <ngx-select-dropdown
      tabindex=""
      inputValidateRef
      [control]="control"
      [formGroup]="frmGroup"
      [multiple]="InputConfig.multiple"
      [formControlName]="control"
      [options]="InputConfig.selectConfig.options"
      [config]="InputConfig.selectConfig.optionConfig"
      [(_value)]="InputConfig.selectConfig.selectedOption"
      (change)="change($event.value)"
      [disabled]="InputConfig?.isDisabled || isDependentDropdown"
    ></ngx-select-dropdown> -->
    <ng-select
      [id]="fieldInfo.fieldName"
      [readonly]="InputConfig?.isDisabled || isDependentDropdown"
      [items]="InputConfig.selectConfig.options"
      inputValidateRef
      [appendTo]="InputConfig?.selectConfig?.appendTo"
      [bindLabel]="InputConfig?.selectConfig?.optionConfig?.displayKey"
      [control]="control"
      [formGroup]="frmGroup"
      [formControlName]="control"
      [multiple]="InputConfig.selectConfig?.multiple"
      [placeholder]="getPlaceHolder()"
      tabindex="0"
      [clearable]="true"
      [selectOnTab]="true"
      [virtualScroll]="true"
    ></ng-select>
  </hcc-custom-validation>
</form>
